<h2 mat-dialog-title class="dialog-title">Desconciliar lançamento</h2>

<mat-dialog-content class="dialog-content">

    <p class="lancamento-info">
        <strong>{{ extrato.memo || '(sem descrição)' }}</strong>
        &nbsp;·&nbsp;
        <span class="valor-info">{{ extrato.valor | abnt:'preco' }}</span>
    </p>

    @if (extrato.movimentacoes.length > 1) {
    <app-alert-card type="warning" class="mb-3 d-block">
        <strong>Atenção:</strong> {{ extrato.movimentacoes.length }} movimentações participam desta
        conciliação e serão desvinculadas.
    </app-alert-card>
    }

    <div class="opcoes-cards">

        <!-- Opção A: Desconciliar apenas -->
        <div class="opcao-card">
            <div class="opcao-card-body">
                <h3 class="opcao-titulo">Desconciliar apenas</h3>
                <p class="opcao-descricao">
                    Remove o vínculo de conciliação. As movimentações e liquidações permanecem como estão; apenas o
                    status de conciliado é revertido.
                </p>
            </div>
            <button mat-stroked-button class="btn-secondary" [disabled]="isSalvando"
                (click)="confirmar(TipoDesconciliacaoEnum.Simples)">
                @if (tipoEmExecucao === TipoDesconciliacaoEnum.Simples) {
                <mat-spinner diameter="16" class="btn-spinner"></mat-spinner>
                } @else {
                Apenas desvincular
                }
            </button>
        </div>

        <!-- Opção B: Desconciliar e voltar ao aberto -->
        <div class="opcao-card">
            <div class="opcao-card-body">
                <h3 class="opcao-titulo">Desconciliar e voltar ao aberto</h3>
                <p class="opcao-descricao">
                    Desfaz tudo: exclui as movimentações geradas, remove liquidações e recalcula o saldo da conta
                    financeira.
                </p>
            </div>
            <button mat-stroked-button class="btn-secondary" [disabled]="isSalvando"
                (click)="confirmar(TipoDesconciliacaoEnum.Completo)">
                @if (tipoEmExecucao === TipoDesconciliacaoEnum.Completo) {
                <mat-spinner diameter="16" class="btn-spinner"></mat-spinner>
                } @else {
                Voltar ao aberto
                }
            </button>
        </div>

    </div>

</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
    <button mat-stroked-button class="btn-secondary" [disabled]="isSalvando" (click)="cancelar()">Cancelar</button>
</mat-dialog-actions>